var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_44943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 11.8003C6.18668 11.8003 7.25 10.737 7.25 9.42529C7.25 8.11362 6.18668 7.05029 4.875 7.05029C3.56332 7.05029 2.5 8.11362 2.5 9.42529C2.5 10.737 3.56332 11.8003 4.875 11.8003Z",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.5503C1.5 14.5557 1.89509 13.6019 2.59835 12.8986C3.30161 12.1954 4.25544 11.8003 5.25 11.8003M8.75 15.5503C8.75 15.0578 8.653 14.5702 8.46455 14.1152C8.27609 13.6603 7.99987 13.2469 7.65165 12.8986C7.30343 12.5504 6.89003 12.2742 6.43506 12.0857C5.98009 11.8973 5.49246 11.8003 5 11.8003",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.80029C11.9367 5.80029 13 4.73697 13 3.42529C13 2.11362 11.9367 1.05029 10.625 1.05029C9.31332 1.05029 8.25 2.11362 8.25 3.42529C8.25 4.73697 9.31332 5.80029 10.625 5.80029Z",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.30029C7.25 7.36529 8.9275 5.80029 11 5.80029M14.5 9.30029C14.5 7.36529 12.8225 5.80029 10.75 5.80029",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_44943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.300293)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.14a5d167228a14272d8e8a13737399b5.svg";
export { ForwardRef as ReactComponent };